import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { SubAccount, SubAccountCore } from '../types/subAccount';
import { deleteRequest, getRequest, postRequest } from './api';
import { getSubAccountsUrl } from './urls/accountUrls';
import { subAccountUrl, subAccountsUrl } from './urls/subAccountUrls';

export const getAllSubAccounts = async (
  clientId: string,
  subClientId: string
): Promise<{ subAccounts?: SubAccount[]; error?: ApiError }> => {
  const response = await getRequest(getSubAccountsUrl, {
    queryParams: { clientId, subClientId, all_items: true },
  });
  return {
    subAccounts: response?.data.items,
    error: response?.error,
  };
};

export const getSubAccounts = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<SubAccount>; error?: ApiError }> => {
  const response = await getRequest(getSubAccountsUrl, {
    queryParams: { clientId, subClientId, page, search },
  });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const deleteSubAccount = async (
  clientId: string,
  subClientId: string,
  subAccountId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(subAccountUrl(subAccountId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateSubAccount = async (subAccount: SubAccountCore): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(subAccountUrl(subAccount._id), {
    body: {
      ...subAccount,
      clientId: subAccount.client._id,
      subClientId: subAccount.subClient._id,
    },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postSubAccount = async (subAccount: SubAccountCore): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(subAccountsUrl, {
    body: {
      ...subAccount,
      clientId: subAccount.client._id,
      subClientId: subAccount.subClient._id,
    },
  });

  return {
    id: response?.data?._id,
    error: response?.error,
  };
};
